import React, { useState } from "react";
import { connect } from "react-redux";
import GroupReportsWrapper from "./GroupReportsWrapper.js";
import {
  filterParams,
  cellRenderer,
  generateOriginalValue,
  handleNumDisplay,
} from "../Reports/utils/ReportUtils";
import moment from "moment";

function GroupRoomRevenueReport(props) {
  // getting the hotel id from the params
  //   const url = new URL(window.location.href);
  //   const hotelId = url.searchParams.get("hotelId");
  //   const hotelCurrency = data.accessControl.hotel.hotel_currency;

  // default hotel currency
  const hotelCurrency = props.data.hotelCurrency;
  // column definitions

  // defining the column headers, etc.
  const columns = [
    {
      field: "hotelId",
      headerName: "Hotel Id",
      hide: false,
      dataType: "varchar",
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },
    {
      field: "hotelName",
      headerName: "Hotel Name",
      hide: false,
      dataType: "varchar",
    },
    {
      field: "bookingId",
      headerName: "Booking ID",
      // cellRendererFramework: (params) => cellRenderer(params),
      dataType: "varchar",
    },
    {
      field: "email",
      headerName: "Email",
      dataType: "varchar",
      hide: true,
    },
    {
      field: "userName",
      headerName: "User name",
      dataType: "varchar",
      hide: false,
    },
    {
      field: "status",
      headerName: "Status",
      dataType: "varchar",
    },
    {
      field: "source",
      headerName: "Source",
      dataType: "varchar",
    },
    {
      field: "bookingAmount",
      headerName: `Booking Amount (${hotelCurrency})`,
      aggFunc: "sum",
      dataType: "float",
      valueGetter: (params) => generateOriginalValue(params, "bookingAmount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
      filter: "agNumberColumnFilter",
    },
    {
      field: "checkIn",
      headerName: "Checkin",
      filter: "agDateColumnFilter",
      filterParams: filterParams,
      dataType: "date",
    },
    {
      field: "checkOut",
      headerName: "Checkout",
      filter: "agDateColumnFilter",
      filterParams: filterParams,
      dataType: "date",
    },
    {
      field: "bookingMadeOn",
      headerName: "Booking Made On",
      filter: "agDateColumnFilter",
      filterParams: filterParams,
      dataType: "date",
    },
    {
      field: "refund",
      headerName: `Refund (${hotelCurrency})`,
      aggFunc: "sum",
      dataType: "float",
      valueGetter: (params) => generateOriginalValue(params, "refund"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
      filter: "agNumberColumnFilter",
    },
    {
      field: "offlinePayment",
      headerName: `Offline Payment (${hotelCurrency})`,
      aggFunc: "sum",
      dataType: "float",
      valueGetter: (params) => generateOriginalValue(params, "offlinePayment"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
      filter: "agNumberColumnFilter",
    },
    {
      field: "servicesAmount",
      headerName: `Services Amount (${hotelCurrency})`,
      aggFunc: "sum",
      dataType: "float",
      valueGetter: (params) => generateOriginalValue(params, "servicesAmount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
      filter: "agNumberColumnFilter",
    },
    {
      field: "paymentExternal",
      headerName: `Payment External (${hotelCurrency})`,
      aggFunc: "sum",
      dataType: "float",
      valueGetter: (params) => generateOriginalValue(params, "paymentExternal"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
      filter: "agNumberColumnFilter",
    },
    {
      field: "externalPaymentCard",
      headerName: `External Payment Card (${hotelCurrency})`,
      aggFunc: "sum",
      dataType: "float",
      valueGetter: (params) =>
        generateOriginalValue(params, "externalPaymentCard"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
      filter: "agNumberColumnFilter",
    },
    {
      field: "pgAmount",
      headerName: `Payment Gateway Amount (${hotelCurrency})`,
      aggFunc: "sum",
      dataType: "float",
      valueGetter: (params) => generateOriginalValue(params, "pgAmount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
      filter: "agNumberColumnFilter",
    },
    {
      field: "totalAmtWithServices",
      headerName: `Total Amount With Services (${hotelCurrency})`,
      aggFunc: "sum",
      dataType: "float",
      valueGetter: (params) =>
        generateOriginalValue(params, "totalAmtWithServices"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
      filter: "agNumberColumnFilter",
    },
    {
      field: "taxesSplit",
      headerName: `Taxes split (${hotelCurrency})`,
      dataType: "varchar",
    },
    {
      field: "totalTaxes",
      headerName: `Total Taxes (${hotelCurrency})`,
      aggFunc: "sum",
      dataType: "float",
      valueGetter: (params) => generateOriginalValue(params, "totalTaxes"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
      filter: "agNumberColumnFilter",
    },
    {
      field: "partialExempt",
      headerName: "Partial Exempt",
      hide: true,
      dataType: "varchar",
    },
    {
      field: "totalExempt",
      headerName: "Total Exempt",
      hide: true,
      dataType: "varchar",
    },
    {
      field: "exemptCount",
      headerName: "Exempt Count",
      hide: true,
      aggFunc: "sum",
      dataType: "integer",
      valueGetter: (params) => generateOriginalValue(params, "exemptCount"),
      valueFormatter: (params) => handleNumDisplay(params, "integer"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "integer"),
      filter: "agNumberColumnFilter",
    },
    {
      field: "totalCount",
      headerName: "Total Count",
      hide: true,
      aggFunc: "sum",
      dataType: "integer",
      valueGetter: (params) => generateOriginalValue(params, "totalCount"),
      valueFormatter: (params) => handleNumDisplay(params, "integer"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "integer"),
      filter: "agNumberColumnFilter",
    },
    {
      field: "excessExempt",
      headerName: "Excess Exempt",
      hide: true,
      dataType: "varchar",
    },
    {
      field: "taxExemptRevenue",
      headerName: `Tax Exempt Revenue (${hotelCurrency})`,
      dataType: "float",
      aggFunc: "sum",
      filter: "agNumberColumnFilter",
      valueGetter: (params) =>
        generateOriginalValue(params, "taxExemptRevenue"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "taxableRevenue",
      headerName: `Taxable Revenue (${hotelCurrency})`,
      dataType: "float",
      aggFunc: "sum",
      filter: "agNumberColumnFilter",
      valueGetter: (params) => generateOriginalValue(params, "taxableRevenue"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "balanceAmount",
      headerName: `Balance Amount (${hotelCurrency})`,
      dataType: "float",
      aggFunc: "sum",
      filter: "agNumberColumnFilter",
      valueGetter: (params) => generateOriginalValue(params, "balanceAmount"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "roomRevenue",
      headerName: `Room Revenue (${hotelCurrency})`,
      dataType: "float",
      aggFunc: "sum",
      filter: "agNumberColumnFilter",
      valueGetter: (params) => generateOriginalValue(params, "roomRevenue"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "roomTaxes",
      headerName: `Room Taxes (${hotelCurrency})`,
      dataType: "float",
      aggFunc: "sum",
      filter: "agNumberColumnFilter",
      valueGetter: (params) => generateOriginalValue(params, "roomTaxes"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => handleNumDisplay(params, "float"),
    },
    {
      field: "taxPerc",
      headerName: `Tax Percentage`,
      dataType: "float",
      aggFunc: "sum",
      filter: "agNumberColumnFilter",
      valueGetter: (params) => generateOriginalValue(params, "taxPerc"),
      valueFormatter: (params) => handleNumDisplay(params, "float"),
      pinnedRowValueFormatter: (params) => "",
    },
  ];

  // Setting the pinned row
  const [pinnedRow, setPinnedRow] = useState(null);
  function createPinnedData(params, rowsData) {
    // let result = {
    //   bookingid_display: "Total",
    //   tax: 0,
    //   commission: 0,
    //   net_amount: 0,
    //   gross_amount: 0,
    //   tds: 0,
    // };

    let result = {};

    for (let i = 0; i < columns.length; i++) {
      if (["integer", "float"].includes(columns[i]["dataType"])) {
        result[columns[i]["field"]] = 0;
      }
    }

    // function updateVals(i) {
    //   result.tax += i.tax;
    //   result.commission += i.commission;
    //   result.net_amount += i.net_amount;
    //   result.gross_amount += i.gross_amount;
    //   result.tds = i.tds;
    // }

    function updateVals(i) {
      Object.keys(result).forEach((fields) => {
        result[fields] += i[`original_${fields}`];
      });
    }

    params.api.getSelectedRows().length === 0
      ? params.api.forEachNodeAfterFilter((row) => updateVals(row.data))
      : params.api.getSelectedRows().map((row) => updateVals(row));

    result["bookingId"] = "Total";

    setPinnedRow([result]);
    params.api.setPinnedBottomRowData([result]);
  }

  return (
    <GroupReportsWrapper
      reportName={"Group Room Revenue Report"}
      columns={columns}
      reportActualType={"roomRevenue"}
      createPinnedData={createPinnedData}
      pinnedRow={pinnedRow}
      grpEmail={props.grpEmail}
      resetToDefault={props.resetToDefault}
    />
  );
}

function mapStateToProps(state) {
  return { data: state.auth.hotels[0] };
}
export default connect(mapStateToProps)(GroupRoomRevenueReport);
